/** Message catalogue for features/opac. Keys: "opac.<area>.<name>". */
export const opacEn = {
  // auth & account
  'opac.auth.authCode': 'Authenticator code',
  'opac.auth.authCodeHelp': '6-digit code from your authenticator app',
  'opac.auth.cardOrUser': 'Card number or username',
  'opac.auth.codeInvalid': 'Please enter a 6-digit code',
  'opac.auth.codeWrong': 'Invalid or expired verification code',
  'opac.auth.confirmPassword': 'Confirm password',
  'opac.auth.contactHint': 'We will send account notices and pickup alerts here',
  'opac.auth.contactRequired': 'Please provide an email address or mobile number',
  'opac.auth.createAccount': 'Create account',
  'opac.auth.dobFuture': 'Date of birth cannot be in the future',
  'opac.auth.emailInvalid': 'Please enter a valid email address',
  'opac.auth.haveAccount': 'Already have an account?',
  'opac.auth.hidePassword': 'Hide password',
  'opac.auth.homeLibrary': 'Home library',
  'opac.auth.marketing': 'Keep me updated about library events, clubs and new arrivals',
  'opac.auth.method': 'Sign-in method',
  'opac.auth.mobile': 'Mobile number',
  'opac.auth.mobileHelp': 'We will send a one-time passcode',
  'opac.auth.mobileInvalid': 'Please enter a valid mobile number',
  'opac.auth.noPreference': 'No preference',
  'opac.auth.otpSent': 'A verification code has been sent to your mobile.',
  'opac.auth.passwordHint': 'At least 8 characters',
  'opac.auth.passwordMismatch': 'Passwords do not match',
  'opac.auth.passwordShort': 'Password must be at least 8 characters long',
  'opac.auth.phoneCode': 'One-time SMS code',
  'opac.auth.registerSubtitle': 'Register for membership to borrow, place holds and access digital resources.',
  'opac.auth.registerTitle': 'Join the library',
  'opac.auth.registrationClosed': 'Online registration is currently closed. Please visit a library branch.',
  'opac.auth.resend': 'Resend code',
  'opac.auth.resent': 'A new verification code was sent.',
  'opac.auth.sendCode': 'Send code',
  'opac.auth.showPassword': 'Show password',
  'opac.auth.signInSubtitle': 'Sign in to view your loans, renew books and manage holds.',
  'opac.auth.smsCode': 'SMS code',
  'opac.auth.twoFactorHelp': 'Enter the 6-digit code from your authenticator device.',
  'opac.auth.twoFactorTitle': 'Two-factor authentication',
  'opac.auth.verifyAndContinue': 'Verify and continue',
  'opac.auth.verifyAndSignIn': 'Verify and sign in',
  'opac.auth.verifyCode': 'Verification code',
  'opac.auth.verifySubtitle': 'We sent a verification code to {destination}. Enter it below to activate your card.',
  'opac.auth.verifyTitle': 'Verify your membership',
  'opac.auth.yourCard': 'Your library card number',

  // profile fields
  'opac.profile.address': 'Street address',
  'opac.profile.city': 'City',
  'opac.profile.dob': 'Date of birth',
  'opac.profile.email': 'Email address',
  'opac.profile.firstName': 'First name',
  'opac.profile.phone': 'Phone number',
  'opac.profile.postalCode': 'PIN / Postal code',
  'opac.profile.state': 'State',
  'opac.profile.surname': 'Surname / Last name',

  // errors & network
  'opac.err.network': 'Network connection error. Please check your internet connection and try again.',
  'opac.err.otpInvalid': 'The verification code entered is invalid or has expired.',

  // availability & items
  'opac.avail.dueBack': 'Due back {date}',
  'opac.avail.noCopiesHelp': 'No physical copies are currently held for this title.',
  'opac.avail.ofAvailable': '{available} of {total} copies available',
  'opac.availabilityByLibrary': 'Availability by library branch',

  // book detail
  'opac.book.audience': 'Target audience',
  'opac.book.availability': 'Availability',
  'opac.book.availabilityHelp': 'Real-time status across library branches. Lost and withdrawn copies are not counted.',
  'opac.book.classification': 'Classification',
  'opac.book.community': 'Community reviews and ratings',
  'opac.book.details': 'Title details',
  'opac.book.edition': 'Edition',
  'opac.book.extent': 'Pages / Extent',
  'opac.book.holdsCount': '{count} holds in queue',
  'opac.book.isbn': 'ISBN',
  'opac.book.language': 'Language',
  'opac.book.notFound': 'Title not found',
  'opac.book.notFoundHelp': 'This title may have been removed or the link is incorrect.',
  'opac.book.publisher': 'Publisher',
  'opac.book.related': 'Related titles',
  'opac.book.alsoBorrowed': 'Readers also borrowed',
  'opac.book.series': 'Series',
  'opac.book.subjects': 'Subjects',
  'opac.book.year': 'Publication year',

  // browse
  'opac.browse.authors': 'Authors',
  'opac.browse.description': 'Explore titles by subject, author, series, tag or popularity.',
  'opac.browse.filter': 'Filter browse list',
  'opac.browse.new': 'New arrivals',
  'opac.browse.noTags': 'No tags available',
  'opac.browse.popular': 'Popular',
  'opac.browse.series': 'Series',
  'opac.browse.subjects': 'Subjects',
  'opac.browse.tags': 'Tags',
  'opac.browse.title': 'Browse collection',

  // courses
  'opac.courses.description': 'Readings and reserve materials for academic courses.',
  'opac.courses.empty': 'No course reserves found',
  'opac.courses.emptyHelp': 'Try searching for a different course code, instructor or department.',
  'opac.courses.items': '{count} items on reserve',
  'opac.courses.noItems': 'No items on reserve for this course yet.',
  'opac.courses.search': 'Search courses by code, title or instructor',
  'opac.courses.section': 'Section',
  'opac.courses.title': 'Course reserves',
  'opac.courses.until': 'Until {date}',

  // events
  'opac.event.addToCalendar': 'Add to calendar',
  'opac.event.cancelBody': 'Are you sure you want to cancel your registration for this event?',
  'opac.event.cancelRegistration': 'Cancel registration',
  'opac.event.cancelTitle': 'Cancel registration',
  'opac.event.cancelled': 'Registration cancelled',
  'opac.event.fee': 'Admission fee',
  'opac.event.free': 'Free',
  'opac.event.full': 'Event full',
  'opac.event.guestDone': 'A confirmation email has been sent to {email}.',
  'opac.event.guestName': 'Your name',
  'opac.event.isCancelled': 'This event has been cancelled.',
  'opac.event.isOver': 'This event has ended.',
  'opac.event.joinWaitlist': 'Join waitlist',
  'opac.event.noRegistration': 'No registration required. Walk-ins welcome.',
  'opac.event.notFound': 'Event not found',
  'opac.event.onWaitlist': '{count} on waitlist',
  'opac.event.openSeating': 'Open seating',
  'opac.event.orGuest': 'Or register as a guest',
  'opac.event.partySize': 'Party size',
  'opac.event.register': 'Register now',
  'opac.event.registered': 'Successfully registered!',
  'opac.event.seats': 'Seats',
  'opac.event.seatsLeft': '{left} of {total} seats left',
  'opac.event.signInToRegister': 'Sign in to register',
  'opac.event.waitlist': 'Waitlist available',
  'opac.event.waitlisted': 'Added to waitlist at position #{position}',
  'opac.event.when': 'When',
  'opac.event.where': 'Where',
  'opac.event.youAreRegistered': 'You are registered ({count} attendees)',
  'opac.events.allAudiences': 'All audiences',
  'opac.events.allCategories': 'All categories',
  'opac.events.audience': 'Audience',
  'opac.events.category': 'Category',
  'opac.events.description': 'Workshops, book clubs, lectures and library activities.',
  'opac.events.emptyHelp': 'Check back soon or explore other branches.',
  'opac.events.title': 'Library events',
  'opac.noEvents': 'No upcoming events',
  'opac.upcomingEvents': 'Upcoming events',

  // facets
  'opac.facet.author': 'Author',
  'opac.facet.availableNow': 'Available now',
  'opac.facet.collection': 'Collection',
  'opac.facet.decade': 'Decade',
  'opac.facet.itemType': 'Item type',
  'opac.facet.language': 'Language',
  'opac.facet.library': 'Library branch',
  'opac.facet.subject': 'Subject',

  // fields & sorts
  'opac.field.any': 'All fields',
  'opac.field.author': 'Author',
  'opac.field.callnumber': 'Call number',
  'opac.field.isbn': 'ISBN',
  'opac.field.publisher': 'Publisher',
  'opac.field.series': 'Series',
  'opac.field.subject': 'Subject',
  'opac.field.title': 'Title',
  'opac.sort.-title': 'Title (Z to A)',
  'opac.sort.-year': 'Year (newest first)',
  'opac.sort.author': 'Author',
  'opac.sort.newest': 'Recently added',
  'opac.sort.popularity': 'Most popular',
  'opac.sort.relevance': 'Relevance',
  'opac.sort.title': 'Title (A to Z)',
  'opac.sort.year': 'Year (oldest first)',

  // holds
  'opac.hold.alreadyHeld': 'Hold already placed',
  'opac.hold.alreadyOnLoan': 'Currently on loan to you',
  'opac.hold.blockedBody': 'Your hold could not be placed due to policy restrictions:',
  'opac.hold.blockedHelp': 'Please resolve any outstanding fees or account restrictions.',
  'opac.hold.blockedTitle': 'Hold not allowed',
  'opac.hold.confirmAndPlace': 'Confirm and place hold',
  'opac.hold.confirmHelp': 'Please review the warnings before proceeding.',
  'opac.hold.confirmTitle': 'Notice before placing hold',
  'opac.hold.expires': 'Hold expires after',
  'opac.hold.expiresHint': 'Leave empty for default expiry',
  'opac.hold.expiresOn': 'Expires on {date}',
  'opac.hold.fee': 'Hold reservation fee',
  'opac.hold.noPickup': 'No pickup locations are currently available for this title.',
  'opac.hold.notes': 'Notes for staff',
  'opac.hold.notifyHint': 'You will be notified via email or SMS when the copy is ready for collection.',
  'opac.hold.pickupAt': 'Pickup branch',
  'opac.hold.pickupHint': 'Select the library branch where you will collect this item.',
  'opac.hold.pickupLibrary': 'Pickup library',
  'opac.hold.pickupRequired': 'Please select a pickup branch.',
  'opac.hold.placedBody': 'Your request for "{title}" has been queued.',
  'opac.hold.placedTitle': 'Hold placed successfully',
  'opac.hold.queue': 'Queue position',
  'opac.hold.queueNote': 'Items are held on the shelf for 7 days once available.',
  'opac.hold.signIn': 'Sign in to reserve',
  'opac.hold.thisCopy': 'Hold this copy',
  'opac.hold.viewHolds': 'View my holds',

  // lists
  'opac.addToList': 'Add to reading list',
  'opac.list.added': 'Added to list',
  'opac.list.createAndAdd': 'Create and add',
  'opac.list.namePlaceholder': 'e.g. Summer Reading, Research 2026',
  'opac.list.newList': 'Create a new list',
  'opac.list.noneYet': 'You have not created any reading lists yet.',
  'opac.lists.description': 'Curated reading collections and staff recommendations.',
  'opac.lists.empty': 'No public lists available',
  'opac.lists.emptyHelp': 'Public reading lists created by librarians will appear here.',
  'opac.lists.noEntries': 'This list does not have any items yet.',
  'opac.lists.title': 'Reading lists',
  'opac.lists.unavailable': 'List not available',
  'opac.lists.unavailableHelp': 'This list is private or has been removed.',

  // resources
  'opac.resources.allTypes': 'All formats',
  'opac.resources.description': 'Access e-books, research databases, journals and streaming media.',
  'opac.resources.empty': 'No electronic resources match your search.',
  'opac.resources.emptyHelp': 'Try adjusting your search terms or filters.',
  'opac.resources.members': 'Members only',
  'opac.resources.open': 'Open access',
  'opac.resources.openLink': 'Access resource',
  'opac.resources.openOnly': 'Show open access only',
  'opac.resources.search': 'Search electronic resources',
  'opac.resources.signInNote': 'Sign in with your library card to unlock member-only digital subscriptions.',
  'opac.resources.title': 'Digital & e-resources',
  'opac.resources.type': 'Format',
  'opac.resources.type.AUDIO': 'Audiobook / Audio',
  'opac.resources.type.BOOK': 'E-Book',
  'opac.resources.type.DATABASE': 'Database',
  'opac.resources.type.JOURNAL': 'E-Journal',
  'opac.resources.type.OTHER': 'Other',
  'opac.resources.type.VIDEO': 'Streaming video',

  // reviews & tags
  'opac.review.addTag': 'Add a tag',
  'opac.review.awaiting': 'Awaiting moderation',
  'opac.review.noTags': 'No community tags yet',
  'opac.review.none': 'No community reviews yet. Be the first to share your thoughts!',
  'opac.review.pending': 'Thank you! Your review has been submitted for moderation.',
  'opac.review.placeholder': 'Share what you thought about this title...',
  'opac.review.post': 'Post review',
  'opac.review.posted': 'Your review was posted!',
  'opac.review.rated': 'Rating saved!',
  'opac.review.ratings': 'Based on {count} ratings',
  'opac.review.reviews': 'Reader reviews',
  'opac.review.signInToRate': 'Sign in to rate',
  'opac.review.tagged': 'Tag added!',
  'opac.review.tags': 'Tags',
  'opac.review.write': 'Write a review',
  'opac.review.yourRating': 'Your rating',

  // rooms & equipment
  'opac.rooms.allKinds': 'All spaces and equipment',
  'opac.rooms.approvalNote': 'This booking requires approval from library staff. You will receive an update shortly.',
  'opac.rooms.attendees': 'Number of attendees',
  'opac.rooms.book': 'Book space',
  'opac.rooms.bookTitle': 'Book {name}',
  'opac.rooms.booked': 'Booking confirmed!',
  'opac.rooms.closedDay': 'The library is closed on this date.',
  'opac.rooms.confirm': 'Confirm booking',
  'opac.rooms.date': 'Booking date',
  'opac.rooms.description': 'Reserve private study rooms, meeting spaces and multimedia equipment.',
  'opac.rooms.duration': 'Booking duration',
  'opac.rooms.empty': 'No rooms or equipment available',
  'opac.rooms.emptyHelp': 'Try picking a different date, time or library branch.',
  'opac.rooms.equipment': 'Equipment',
  'opac.rooms.fee': 'Estimated fee: {amount}',
  'opac.rooms.instant': 'Instant booking',
  'opac.rooms.kind': 'Facility type',
  'opac.rooms.needsApproval': 'Requires approval',
  'opac.rooms.noSlots': 'No available time slots on this date.',
  'opac.rooms.perHour': '{amount} / hour',
  'opac.rooms.purpose': 'Booking purpose',
  'opac.rooms.request': 'Request booking',
  'opac.rooms.requested': 'Booking requested!',
  'opac.rooms.rooms': 'Study & meeting rooms',
  'opac.rooms.seats': '{count} seats',
  'opac.rooms.signIn': 'Sign in to book',
  'opac.rooms.signInHelp': 'Please sign in with your library account to make a reservation.',
  'opac.rooms.slots': 'Select a time slot',
  'opac.rooms.title': 'Study rooms & equipment',
  'opac.rooms.viewBookings': 'View my bookings',

  // search UI
  'opac.search.activeFilters': 'Active filters',
  'opac.search.alertsOff': 'Alerts off',
  'opac.search.alertsOn': 'Alerts on',
  'opac.search.clearFilters': 'Clear filters',
  'opac.search.didYouMean': 'Did you mean:',
  'opac.search.field': 'Search field',
  'opac.search.filtersOnly': 'Filter search',
  'opac.search.grid': 'Grid view',
  'opac.search.list': 'List view',
  'opac.search.noResults': 'No matching results found',
  'opac.search.noResultsHelp': 'Check the spelling, broaden your search terms, or try clearing some filters.',
  'opac.search.noneSaved': 'No saved searches',
  'opac.search.noneSavedHelp': 'Save your favourite searches to quickly run them again or receive alerts.',
  'opac.search.notify': 'Email me when new titles match',
  'opac.search.notifyHelp': 'Receive notifications when matching books arrive at the library.',
  'opac.search.resultsFor': 'Search results for "{q}"',
  'opac.search.save': 'Save search',
  'opac.search.saveName': 'Saved search name',
  'opac.search.saved': 'Saved searches',
  'opac.search.savedToast': 'Search saved successfully!',
  'opac.search.showResults': 'Show {count} results',
  'opac.search.sort': 'Sort order',
  'opac.search.suggestPurchase': 'Suggest a title for purchase',
  'opac.search.title': 'Catalogue search',
  'opac.search.view': 'View style',

  // miscellaneous & home
  'opac.by': 'by',
  'opac.byOwner': 'Curated by {name}',
  'opac.cameraDenied': 'Camera permission denied or camera not found',
  'opac.chip.fiction': 'Fiction',
  'opac.chip.hindi': 'Hindi Literature',
  'opac.chip.science': 'Science & Nature',
  'opac.chip.upsc': 'Civil Services / UPSC',
  'opac.closedNow': 'Closed now',
  'opac.closedToday': 'Closed today',
  'opac.emptyShelf': 'No titles on shelf',
  'opac.heroEyebrow': 'Discover · Learn · Connect',
  'opac.hoursSoon': 'Opening hours updating soon',
  'opac.libraryHours': 'Library hours',
  'opac.news': 'Library news & notices',
  'opac.nextClosure': 'Upcoming closure: {title} on {date}',
  'opac.noRatings': 'No ratings yet',
  'opac.openNow': 'Open now',
  'opac.qrAlt': 'QR code for {title}',
  'opac.qrHelp': 'Scan with a mobile phone camera to open on mobile',
  'opac.ratingOf': '{value} out of 5 stars ({count} ratings)',
  'opac.scanHint': 'Scan an ISBN barcode with your device camera',
  'opac.scanIsbn': 'Scan book barcode',
  'opac.scanIsbnHelp': 'Point camera at the barcode on the back of the book',
  'opac.seeAll': 'See all',
  'opac.share': 'Share title',
  'opac.staffPicks': 'Staff recommendations',
  'opac.staffPicksHelp': 'Hand-picked collections recommended by library curators',
  'opac.stat.copies': 'Total copies',
  'opac.stat.loans': 'Loans (last 30 days)',
  'opac.stat.members': 'Active members',
  'opac.stat.titles': 'Titles in collection',
  'opac.statFoot': 'Plus {events} upcoming cultural events & workshops',
  'opac.titlesCount': '{count} titles',
  'opac.trySearching': 'Popular searches',
  'opac.updated': 'Updated {date}',
  'card.expiredAgo': "Expired {days} days ago",
  'card.expiresSoon': "Expires in {days} days",
  'card.fullscreen': "Fullscreen card",
  'card.libraryCard': "Library card",
  'card.noExpiry': "No expiry",
  'card.number': "Card number",
  'card.offlineCopy': "Offline cached copy",
  'card.qrAlt': "Digital library card barcode and QR code",
  'card.qrUnavailable': "QR unavailable",
  'card.savedOffline': "Available offline",
  'card.scanHelp': "Present this barcode or QR code at self-checkout or the circulation desk.",
  'card.validThru': "Valid through",
  'kiosk.askStaff': "Please speak with library staff at the circulation desk.",
  'kiosk.backspace': "Backspace",
  'kiosk.borrow': "Borrow",
  'kiosk.borrowed': "Items borrowed",
  'kiosk.cardField': "Card barcode",
  'kiosk.cardHelp': "Scan or type your library card barcode to begin.",
  'kiosk.cardPlaceholder': "Scan or enter card barcode",
  'kiosk.continue': "Continue",
  'kiosk.differentCard': "Use a different card",
  'kiosk.disabledHelp': "Self-checkout is not available right now. Please visit the circulation desk.",
  'kiosk.dueOn': "Due back: {date}",
  'kiosk.enterPin': "Enter your PIN",
  'kiosk.fine': "Overdue fine: ₹{amount} ({days} days)",
  'kiosk.finish': "Finish & log out",
  'kiosk.itemField': "Item barcode",
  'kiosk.itemPlaceholder': "Scan book barcode",
  'kiosk.loansNow': "Active loans on account: {count}",
  'kiosk.mode': "Checkout mode",
  'kiosk.notProcessed': "Items not processed",
  'kiosk.nothing': "No items scanned in this session.",
  'kiosk.pinEntered': "{count} digits entered",
  'kiosk.pinPrompt': "Enter 4-6 digit PIN",
  'kiosk.receipt': "Session receipt",
  'kiosk.return': "Return",
  'kiosk.returned': "Returned successfully",
  'kiosk.returnedHeading': "Items returned",
  'kiosk.scanReturn': "Scan items to return",
  'kiosk.thanks': "Thank you!",
  'kiosk.timedOut': "Session timed out due to inactivity.",
  'kiosk.touchToStart': "Touch to start",
  'kiosk.unreachable': "Kiosk system offline",
  'opac.account.cannotBorrow': "Borrowing privileges are currently suspended on your account.",
  'opac.account.debarred': "Account restricted",
  'opac.account.dueNext': "Next due dates",
  'opac.account.dueSoon': "Due soon",
  'opac.account.expired': "Membership expired",
  'opac.account.expiredHelp': "Your library membership expired on {date}. Please visit the library desk to renew.",
  'opac.account.holdsReady': "Ready for pickup",
  'opac.account.noBookings': "No room or equipment bookings",
  'opac.account.noEvents': "No event registrations",
  'opac.account.noLoans': "No active loans",
  'opac.account.openRequests': "Open requests",
  'opac.account.sections': "Account sections",
  'opac.account.unread': "Unread notices",
  'opac.account.welcome': "Welcome back,",
  'opac.dueSoon': "Due soon",
  'opac.dueToday': "Due today",
  'opac.event.waitlistPos': "Waitlist #{position}",
  'opac.fines.amount': "Amount",
  'opac.fines.balance': "Current balance",
  'opac.fines.credits': "Available credits",
  'opac.fines.description': "Description",
  'opac.fines.dismissed': "Payment cancelled.",
  'opac.fines.empty': "No fine transactions",
  'opac.fines.emptyHelp': "You have no outstanding charges or payments recorded.",
  'opac.fines.outstanding': "Total outstanding",
  'opac.fines.paidBody': "Your payment was recorded successfully.",
  'opac.fines.paidTitle': "Payment of {amount} successful",
  'opac.fines.pay': "Pay {amount}",
  'opac.fines.payAtDesk': "Pay at desk",
  'opac.fines.providerFailed': "Unable to launch payment gateway. Please try again or pay at the desk.",
  'opac.fines.receipt': "Receipt #{number}",
  'opac.fines.sandboxNote': "Test payment mode (sandbox)",
  'opac.fines.secureNote': "Payments are processed securely via encrypted gateway.",
  'opac.fines.statement': "Account statement",
  'opac.fines.toPay': "Pay outstanding fines",
  'opac.fines.voided': "Voided",
  'opac.history.clear': "Clear reading history",
  'opac.history.clearBody': "Are you sure you want to delete your entire borrowing history? This cannot be undone.",
  'opac.history.clearTitle': "Clear reading history?",
  'opac.history.cleared': "Reading history cleared.",
  'opac.history.empty': "No reading history",
  'opac.history.emptyHelp': "Books you return will be recorded here if reading history is enabled.",
  'opac.history.off': "Reading history is disabled",
  'opac.history.offHelp': "Turn on history recording in your privacy settings to keep track of books you have read.",
  'opac.history.policy.DEFAULT': "Library default",
  'opac.history.policy.FOREVER': "Keep forever",
  'opac.history.policy.NEVER': "Do not record",
  'opac.history.privacy': "Reading history privacy",
  'opac.history.privacyHelp.DEFAULT': "Follows library retention policy.",
  'opac.history.privacySaved': "Privacy preferences saved.",
  'opac.history.returned': "Returned {date}",
  'opac.history.search': "Search reading history",
  'opac.holds.cancelBody': "Are you sure you want to cancel your hold for \"{title}\"?",
  'opac.holds.cancelHold': "Cancel hold",
  'opac.holds.cancelTitle': "Cancel hold?",
  'opac.holds.cancelledToast': "Hold cancelled.",
  'opac.holds.edit': "Edit hold",
  'opac.holds.empty': "No holds placed",
  'opac.holds.emptyHelp': "Search the catalogue and place holds on titles to collect them when available.",
  'opac.holds.pickupBy': "Collect by",
  'opac.holds.pickupByDate': "Collect by {date}",
  'opac.holds.placedOn': "Placed on {date}",
  'opac.holds.readyHelp': "Please collect your items from the holding desk before the pickup deadline.",
  'opac.holds.readyTitle': "{count} holds ready for pickup!",
  'opac.holds.resume': "Resume hold",
  'opac.holds.resumedToast': "Hold resumed.",
  'opac.holds.showHistory': "Show past holds",
  'opac.holds.status.CANCELLED': "Cancelled",
  'opac.holds.status.EXPIRED': "Expired",
  'opac.holds.status.FILLED': "Collected",
  'opac.holds.status.IN_PROCESSING': "In processing",
  'opac.holds.status.IN_TRANSIT': "In transit",
  'opac.holds.status.PENDING': "Waiting in queue",
  'opac.holds.status.WAITING': "Ready for pickup",
  'opac.holds.suspend': "Suspend hold",
  'opac.holds.suspendHint': "Your place in queue is preserved while suspended.",
  'opac.holds.suspendUntil': "Suspend until",
  'opac.holds.suspended': "Suspended",
  'opac.holds.suspendedToast': "Hold suspended.",
  'opac.holds.suspendedUntil': "Suspended until {date}",
  'opac.holds.updated': "Hold updated.",
  'opac.ill.article': "Article or chapter title",
  'opac.ill.articleHint': "For journal or book chapter requests",
  'opac.ill.cancel': "Cancel request",
  'opac.ill.cancelTitle': "Cancel interlibrary loan request?",
  'opac.ill.cancelled': "Interlibrary loan request cancelled.",
  'opac.ill.empty': "No interlibrary loan requests",
  'opac.ill.emptyHelp': "Need a book or journal from another library system? Submit an ILL request.",
  'opac.ill.fee': "ILL fee: ₹{amount}",
  'opac.ill.help': "Request books and articles not held in Lumina from partner libraries.",
  'opac.ill.neededBy': "Needed by {date}",
  'opac.ill.neededByField': "Needed by date",
  'opac.ill.new': "New interlibrary loan request",
  'opac.ill.requested': "Requested on {date}",
  'opac.ill.send': "Submit request",
  'opac.ill.sent': "Interlibrary loan request submitted.",
  'opac.list.deleteBody': "Are you sure you want to delete \"{name}\"?",
  'opac.list.deleteTitle': "Delete reading list?",
  'opac.list.deleted': "Reading list deleted.",
  'opac.list.description': "Description",
  'opac.list.edit': "Edit list",
  'opac.list.emptyList': "List is empty",
  'opac.list.emptyListHelp': "Search titles in the catalogue to add them to this list.",
  'opac.list.moveDown': "Move down",
  'opac.list.moveUp': "Move up",
  'opac.list.none': "No lists yet",
  'opac.list.noneHelp': "Create reading lists to organise your reading and research.",
  'opac.list.saved': "List saved.",
  'opac.list.shareLink': "Share link",
  'opac.list.stopSharing': "Stop sharing",
  'opac.list.visibility': "Visibility",
  'opac.list.visibility.PRIVATE': "Private",
  'opac.list.visibilityHelp.PRIVATE': "Only visible to you.",
  'opac.loans.cannotRenew': "Cannot be renewed",
  'opac.loans.daysOverdue': "{count} days overdue",
  'opac.loans.empty': "No active loans",
  'opac.loans.emptyHelp': "Items you borrow from any library branch will appear here.",
  'opac.loans.renewAllResult': "Renewed {renewed} items ({failed} failed)",
  'opac.loans.renewFrom': "Available to renew from {date}",
  'opac.loans.renewalsLeft': "{count} renewals remaining",
  'opac.loans.renewed': "Loan renewed successfully.",
  'opac.loans.renewedTo': "Renewed until {date}",
  'opac.me.address2': "Address line 2",
  'opac.me.allRead': "All notifications marked as read.",
  'opac.me.appearance': "Display & Appearance",
  'opac.me.changePassword': "Change password",
  'opac.me.changePhoto': "Change photo",
  'opac.me.currentPassword': "Current password",
  'opac.me.digest': "Send daily digest",
  'opac.me.language': "Preferred language",
  'opac.me.markAllRead': "Mark all as read",
  'opac.me.markRead': "Mark read",
  'opac.me.medium.EMAIL': "Email",
  'opac.me.member': "Member since {date}",
  'opac.me.messaging': "Notification preferences",
  'opac.me.messagingHelp': "Choose how and when the library contacts you.",
  'opac.me.nameLocked': "To update your legal name, please contact the circulation desk.",
  'opac.me.newPassword': "New password",
  'opac.me.noNotifications': "No notifications",
  'opac.me.noNotificationsHelp': "Pickup notices, due date reminders and library updates will appear here.",
  'opac.me.noticeType': "Notice type",
  'opac.me.passwordChanged': "Password updated successfully.",
  'opac.me.photoSaved': "Profile photo saved.",
  'opac.me.prefsSaved': "Notification preferences saved.",
  'opac.me.saved': "Profile saved.",
  'opac.me.secondaryEmail': "Secondary email",
  'opac.me.theme': "Theme",
  'opac.me.themeDark': "Dark",
  'opac.me.themeLight': "Light",
  'opac.me.themeSystem': "System default",
  'opac.rooms.bookings': "My bookings",
  'opac.rooms.cancel': "Cancel booking",
  'opac.rooms.cancelTitle': "Cancel room booking?",
  'opac.rooms.cancelled': "Booking cancelled.",
  'opac.suggest.author': "Author",
  'opac.suggest.empty': "No purchase suggestions",
  'opac.suggest.emptyHelp': "Would you like the library to acquire a book? Submit a purchase suggestion.",
  'opac.suggest.help': "Suggest titles for the library collection. Librarians will review your request.",
  'opac.suggest.new': "Suggest a purchase",
  'opac.suggest.publisher': "Publisher",
  'opac.suggest.reason': "Reason for suggestion",
  'opac.suggest.send': "Submit suggestion",
  'opac.suggest.sent': "Purchase suggestion submitted.",
  'opac.suggest.titleField': "Title",
  'opac.suggest.withdraw': "Withdraw suggestion",
  'opac.suggest.withdrawTitle': "Withdraw purchase suggestion?",
  'opac.suggest.withdrawn': "Purchase suggestion withdrawn.",
} as const;

export const opacHi: Record<keyof typeof opacEn, string> = {
  // auth & account
  'opac.auth.authCode': 'प्रमाणीकरण कोड',
  'opac.auth.authCodeHelp': 'अपने प्रमाणीकरण ऐप से 6-अंकीय कोड दर्ज करें',
  'opac.auth.cardOrUser': 'कार्ड संख्या या उपयोगकर्ता नाम',
  'opac.auth.codeInvalid': 'कृपया 6-अंकीय कोड दर्ज करें',
  'opac.auth.codeWrong': 'अमान्य या समाप्त सत्यापन कोड',
  'opac.auth.confirmPassword': 'पासवर्ड की पुष्टि करें',
  'opac.auth.contactHint': 'हम खाते की सूचनाएं और पिकअप अलर्ट यहाँ भेजेंगे',
  'opac.auth.contactRequired': 'कृपया ईमेल पता या मोबाइल नंबर प्रदान करें',
  'opac.auth.createAccount': 'खाता बनाएँ',
  'opac.auth.dobFuture': 'जन्म तिथि भविष्य की नहीं हो सकती',
  'opac.auth.emailInvalid': 'कृपया एक मान्य ईमेल पता दर्ज करें',
  'opac.auth.haveAccount': 'क्या आपके पास पहले से खाता है?',
  'opac.auth.hidePassword': 'पासवर्ड छिपाएँ',
  'opac.auth.homeLibrary': 'गृह पुस्तकालय',
  'opac.auth.marketing': 'मुझे पुस्तकालय के कार्यक्रमों, क्लबों और नई आवक के बारे में सूचित रखें',
  'opac.auth.method': 'साइन-इन विधि',
  'opac.auth.mobile': 'मोबाइल नंबर',
  'opac.auth.mobileHelp': 'हम एक बार का पासकोड भेजेंगे',
  'opac.auth.mobileInvalid': 'कृपया एक मान्य मोबाइल नंबर दर्ज करें',
  'opac.auth.noPreference': 'कोई प्राथमिकता नहीं',
  'opac.auth.otpSent': 'आपके मोबाइल पर एक सत्यापन कोड भेजा गया है।',
  'opac.auth.passwordHint': 'कम से कम 8 अक्षर',
  'opac.auth.passwordMismatch': 'पासवर्ड मेल नहीं खाते',
  'opac.auth.passwordShort': 'पासवर्ड कम से कम 8 अक्षरों का होना चाहिए',
  'opac.auth.phoneCode': 'एक बार का एसएमएस कोड',
  'opac.auth.registerSubtitle': 'उधार लेने, होल्ड लगाने और डिजिटल संसाधनों तक पहुँचने के लिए सदस्यता हेतु पंजीकरण करें।',
  'opac.auth.registerTitle': 'पुस्तकालय से जुड़ें',
  'opac.auth.registrationClosed': 'ऑनलाइन पंजीकरण वर्तमान में बंद है। कृपया किसी पुस्तकालय शाखा में जाएँ।',
  'opac.auth.resend': 'कोड पुनः भेजें',
  'opac.auth.resent': 'एक नया सत्यापन कोड भेजा गया।',
  'opac.auth.sendCode': 'कोड भेजें',
  'opac.auth.showPassword': 'पासवर्ड दिखाएँ',
  'opac.auth.signInSubtitle': 'अपने ऋण देखने, पुस्तकों का नवीनीकरण करने और होल्ड प्रबंधित करने के लिए साइन इन करें।',
  'opac.auth.smsCode': 'एसएमएस कोड',
  'opac.auth.twoFactorHelp': 'अपने प्रमाणीकरण उपकरण से 6-अंकीय कोड दर्ज करें।',
  'opac.auth.twoFactorTitle': 'दो-चरणीय प्रमाणीकरण',
  'opac.auth.verifyAndContinue': 'सत्यापित करें और जारी रखें',
  'opac.auth.verifyAndSignIn': 'सत्यापित करें और साइन इन करें',
  'opac.auth.verifyCode': 'सत्यापन कोड',
  'opac.auth.verifySubtitle': 'हमने {destination} पर एक सत्यापन कोड भेजा है। अपने कार्ड को सक्रिय करने के लिए इसे नीचे दर्ज करें।',
  'opac.auth.verifyTitle': 'अपनी सदस्यता सत्यापित करें',
  'opac.auth.yourCard': 'आपका पुस्तकालय कार्ड नंबर',

  // profile fields
  'opac.profile.address': 'पता',
  'opac.profile.city': 'शहर',
  'opac.profile.dob': 'जन्म तिथि',
  'opac.profile.email': 'ईमेल पता',
  'opac.profile.firstName': 'पहला नाम',
  'opac.profile.phone': 'फ़ोन नंबर',
  'opac.profile.postalCode': 'पिन / पोस्टल कोड',
  'opac.profile.state': 'राज्य',
  'opac.profile.surname': 'उपनाम / अंतिम नाम',

  // errors & network
  'opac.err.network': 'नेटवर्क कनेक्शन त्रुटि। कृपया अपना इंटरनेट कनेक्शन जांचें और पुनः प्रयास करें।',
  'opac.err.otpInvalid': 'दर्ज किया गया सत्यापन कोड अमान्य है या समाप्त हो गया है।',

  // availability & items
  'opac.avail.dueBack': 'देय वापसी तिथि {date}',
  'opac.avail.noCopiesHelp': 'वर्तमान में इस शीर्षक के लिए कोई भौतिक प्रति उपलब्ध नहीं है।',
  'opac.avail.ofAvailable': '{total} प्रतियों में से {available} उपलब्ध',
  'opac.availabilityByLibrary': 'पुस्तकालय शाखा द्वारा उपलब्धता',

  // book detail
  'opac.book.audience': 'लक्षित पाठक',
  'opac.book.availability': 'उपलब्धता',
  'opac.book.availabilityHelp': 'पुस्तकालय शाखाओं में रीयल-टाइम स्थिति। खोई हुई और हटाई गई प्रतियां गिनी नहीं जातीं।',
  'opac.book.classification': 'वर्गीकरण',
  'opac.book.community': 'सामुदायिक समीक्षाएँ और रेटिंग',
  'opac.book.details': 'शीर्षक विवरण',
  'opac.book.edition': 'संस्करण',
  'opac.book.extent': 'पृष्ठ / विस्तार',
  'opac.book.holdsCount': 'कतार में {count} होल्ड',
  'opac.book.isbn': 'ISBN',
  'opac.book.language': 'भाषा',
  'opac.book.notFound': 'शीर्षक नहीं मिला',
  'opac.book.notFoundHelp': 'यह शीर्षक हटा दिया गया हो सकता है या लिंक गलत है।',
  'opac.book.publisher': 'प्रकाशक',
  'opac.book.related': 'संबंधित शीर्षक',
  'opac.book.alsoBorrowed': 'पाठकों ने ये भी पढ़ा',
  'opac.book.series': 'श्रृंखला',
  'opac.book.subjects': 'विषय',
  'opac.book.year': 'प्रकाशन वर्ष',

  // browse
  'opac.browse.authors': 'लेखक',
  'opac.browse.description': 'विषय, लेखक, श्रृंखला, टैग या लोकप्रियता के अनुसार शीर्षक खोजें।',
  'opac.browse.filter': 'ब्राउज़ सूची फ़िल्टर करें',
  'opac.browse.new': 'नई आवक',
  'opac.browse.noTags': 'कोई टैग उपलब्ध नहीं',
  'opac.browse.popular': 'लोकप्रिय',
  'opac.browse.series': 'श्रृंखला',
  'opac.browse.subjects': 'विषय',
  'opac.browse.tags': 'टैग',
  'opac.browse.title': 'संग्रह ब्राउज़ करें',

  // courses
  'opac.courses.description': 'शैक्षणिक पाठ्यक्रमों के लिए पठन और आरक्षित सामग्री।',
  'opac.courses.empty': 'कोई पाठ्यक्रम आरक्षित नहीं मिला',
  'opac.courses.emptyHelp': 'एक अलग पाठ्यक्रम कोड, प्रशिक्षक या विभाग खोजें।',
  'opac.courses.items': 'आरक्षित में {count} मदें',
  'opac.courses.noItems': 'इस पाठ्यक्रम के लिए अभी कोई मद आरक्षित नहीं है।',
  'opac.courses.search': 'कोड, शीर्षक या प्रशिक्षक द्वारा पाठ्यक्रम खोजें',
  'opac.courses.section': 'अनुभाग',
  'opac.courses.title': 'पाठ्यक्रम आरक्षित',
  'opac.courses.until': '{date} तक',

  // events
  'opac.event.addToCalendar': 'कैलेंडर में जोड़ें',
  'opac.event.cancelBody': 'क्या आप वाकई इस कार्यक्रम के लिए अपना पंजीकरण रद्द करना चाहते हैं?',
  'opac.event.cancelRegistration': 'पंजीकरण रद्द करें',
  'opac.event.cancelTitle': 'पंजीकरण रद्द करें',
  'opac.event.cancelled': 'पंजीकरण रद्द कर दिया गया',
  'opac.event.fee': 'प्रवेश शुल्क',
  'opac.event.free': 'निःशुल्क',
  'opac.event.full': 'कार्यक्रम पूर्ण है',
  'opac.event.guestDone': '{email} पर एक पुष्टिकरण ईमेल भेजा गया है।',
  'opac.event.guestName': 'आपका नाम',
  'opac.event.isCancelled': 'यह कार्यक्रम रद्द कर दिया गया है।',
  'opac.event.isOver': 'यह कार्यक्रम समाप्त हो चुका है।',
  'opac.event.joinWaitlist': 'प्रतीक्षा सूची में शामिल हों',
  'opac.event.noRegistration': 'किसी पंजीकरण की आवश्यकता नहीं है। सीधे पधारें।',
  'opac.event.notFound': 'कार्यक्रम नहीं मिला',
  'opac.event.onWaitlist': 'प्रतीक्षा सूची में {count}',
  'opac.event.openSeating': 'खुली बैठक व्यवस्था',
  'opac.event.orGuest': 'या अतिथि के रूप में पंजीकरण करें',
  'opac.event.partySize': 'व्यक्तियों की संख्या',
  'opac.event.register': 'अभी पंजीकरण करें',
  'opac.event.registered': 'सफलतापूर्वक पंजीकृत!',
  'opac.event.seats': 'सीटें',
  'opac.event.seatsLeft': '{total} में से {left} सीटें शेष',
  'opac.event.signInToRegister': 'पंजीकरण के लिए साइन इन करें',
  'opac.event.waitlist': 'प्रतीक्षा सूची उपलब्ध',
  'opac.event.waitlisted': 'प्रतीक्षा सूची में स्थान #{position} पर जोड़ा गया',
  'opac.event.when': 'कब',
  'opac.event.where': 'कहाँ',
  'opac.event.youAreRegistered': 'आप पंजीकृत हैं ({count} प्रतिभागी)',
  'opac.events.allAudiences': 'सभी दर्शक',
  'opac.events.allCategories': 'सभी श्रेणियां',
  'opac.events.audience': 'दर्शक',
  'opac.events.category': 'श्रेणी',
  'opac.events.description': 'कार्यशालाएं, पुस्तक क्लब, व्याख्यान और पुस्तकालय गतिविधियां।',
  'opac.events.emptyHelp': 'जल्द ही पुनः जांचें या अन्य शाखाओं का अन्वेषण करें।',
  'opac.events.title': 'पुस्तकालय कार्यक्रम',
  'opac.noEvents': 'कोई आगामी कार्यक्रम नहीं',
  'opac.upcomingEvents': 'आगामी कार्यक्रम',

  // facets
  'opac.facet.author': 'लेखक',
  'opac.facet.availableNow': 'अभी उपलब्ध',
  'opac.facet.collection': 'संग्रह',
  'opac.facet.decade': 'दशक',
  'opac.facet.itemType': 'मद का प्रकार',
  'opac.facet.language': 'भाषा',
  'opac.facet.library': 'पुस्तकालय शाखा',
  'opac.facet.subject': 'विषय',

  // fields & sorts
  'opac.field.any': 'सभी फ़ील्ड',
  'opac.field.author': 'लेखक',
  'opac.field.callnumber': 'कॉल नंबर',
  'opac.field.isbn': 'ISBN',
  'opac.field.publisher': 'प्रकाशक',
  'opac.field.series': 'श्रृंखला',
  'opac.field.subject': 'विषय',
  'opac.field.title': 'शीर्षक',
  'opac.sort.-title': 'शीर्षक (ज्ञ से अ)',
  'opac.sort.-year': 'वर्ष (नवीनतम पहले)',
  'opac.sort.author': 'लेखक',
  'opac.sort.newest': 'हाल ही में जोड़ा गया',
  'opac.sort.popularity': 'सबसे लोकप्रिय',
  'opac.sort.relevance': 'प्रासंगिकता',
  'opac.sort.title': 'शीर्षक (अ से ज्ञ)',
  'opac.sort.year': 'वर्ष (सबसे पुराना पहले)',

  // holds
  'opac.hold.alreadyHeld': 'होल्ड पहले ही लगा हुआ है',
  'opac.hold.alreadyOnLoan': 'वर्तमान में आपको उधार दिया गया है',
  'opac.hold.blockedBody': 'नीति प्रतिबंधों के कारण आपका होल्ड नहीं लगाया जा सका:',
  'opac.hold.blockedHelp': 'कृपया किसी भी बकाया शुल्क या खाता प्रतिबंध को हल करें।',
  'opac.hold.blockedTitle': 'होल्ड की अनुमति नहीं है',
  'opac.hold.confirmAndPlace': 'पुष्टि करें और होल्ड लगाएँ',
  'opac.hold.confirmHelp': 'आगे बढ़ने से पहले कृपया चेतावनियों की समीक्षा करें।',
  'opac.hold.confirmTitle': 'होल्ड लगाने से पहले सूचना',
  'opac.hold.expires': 'होल्ड समाप्ति समय',
  'opac.hold.expiresHint': 'डिफ़ॉल्ट समाप्ति के लिए खाली छोड़ें',
  'opac.hold.expiresOn': '{date} को समाप्त होगा',
  'opac.hold.fee': 'होल्ड आरक्षण शुल्क',
  'opac.hold.noPickup': 'वर्तमान में इस शीर्षक के लिए कोई पिकअप स्थान उपलब्ध नहीं है।',
  'opac.hold.notes': 'कर्मचारियों के लिए टिप्पणियाँ',
  'opac.hold.notifyHint': 'जब प्रति संग्रह के लिए तैयार होगी तब आपको ईमेल या एसएमएस के माध्यम से सूचित किया जाएगा।',
  'opac.hold.pickupAt': 'पिकअप शाखा',
  'opac.hold.pickupHint': 'वह पुस्तकालय शाखा चुनें जहाँ से आप यह वस्तु एकत्र करेंगे।',
  'opac.hold.pickupLibrary': 'पिकअप पुस्तकालय',
  'opac.hold.pickupRequired': 'कृपया एक पिकअप शाखा चुनें।',
  'opac.hold.placedBody': '"{title}" के लिए आपका अनुरोध कतारबद्ध कर दिया गया है।',
  'opac.hold.placedTitle': 'होल्ड सफलतापूर्वक लगाया गया',
  'opac.hold.queue': 'कतार स्थिति',
  'opac.hold.queueNote': 'उपलब्ध होने के बाद वस्तुएं शेल्फ पर 7 दिनों तक रखी जाती हैं।',
  'opac.hold.signIn': 'आरक्षित करने के लिए साइन इन करें',
  'opac.hold.thisCopy': 'इस प्रति को आरक्षित करें',
  'opac.hold.viewHolds': 'मेरे होल्ड देखें',

  // lists
  'opac.addToList': 'पठन सूची में जोड़ें',
  'opac.list.added': 'सूची में जोड़ा गया',
  'opac.list.createAndAdd': 'बनाएँ और जोड़ें',
  'opac.list.namePlaceholder': 'उदा. ग्रीष्मकालीन पठन, अनुसंधान 2026',
  'opac.list.newList': 'एक नई सूची बनाएँ',
  'opac.list.noneYet': 'आपने अभी तक कोई पठन सूची नहीं बनाई है।',
  'opac.lists.description': 'क्यूरेटेड पठन संग्रह और कर्मचारियों की सिफारिशें।',
  'opac.lists.empty': 'कोई सार्वजनिक सूची उपलब्ध नहीं है',
  'opac.lists.emptyHelp': 'पुस्तकालयाध्यक्षों द्वारा बनाई गई सार्वजनिक पठन सूचियाँ यहाँ दिखाई देंगी।',
  'opac.lists.noEntries': 'इस सूची में अभी कोई वस्तु नहीं है।',
  'opac.lists.title': 'पठन सूचियाँ',
  'opac.lists.unavailable': 'सूची उपलब्ध नहीं है',
  'opac.lists.unavailableHelp': 'यह सूची निजी है या हटा दी गई है।',

  // resources
  'opac.resources.allTypes': 'सभी प्रारूप',
  'opac.resources.description': 'ई-पुस्तकों, अनुसंधान डेटाबेस, पत्रिकाओं और स्ट्रीमिंग मीडिया तक पहुँचें।',
  'opac.resources.empty': 'आपकी खोज से कोई इलेक्ट्रॉनिक संसाधन मेल नहीं खाता।',
  'opac.resources.emptyHelp': 'अपने खोज शब्दों या फ़िल्टर को समायोजित करने का प्रयास करें।',
  'opac.resources.members': 'केवल सदस्यों के लिए',
  'opac.resources.open': 'खुली पहुँच',
  'opac.resources.openLink': 'संसाधन तक पहुँचें',
  'opac.resources.openOnly': 'केवल खुली पहुँच दिखाएँ',
  'opac.resources.search': 'इलेक्ट्रॉनिक संसाधन खोजें',
  'opac.resources.signInNote': 'केवल-सदस्यीय डिजिटल सदस्यताओं को अनलॉक करने के लिए अपने पुस्तकालय कार्ड से साइन इन करें।',
  'opac.resources.title': 'डिजिटल और ई-संसाधन',
  'opac.resources.type': 'प्रारूप',
  'opac.resources.type.AUDIO': 'ऑडियोबुक / ऑडियो',
  'opac.resources.type.BOOK': 'ई-पुस्तक',
  'opac.resources.type.DATABASE': 'डेटाबेस',
  'opac.resources.type.JOURNAL': 'ई-पत्रिका',
  'opac.resources.type.OTHER': 'अन्य',
  'opac.resources.type.VIDEO': 'स्ट्रीमिंग वीडियो',

  // reviews & tags
  'opac.review.addTag': 'एक टैग जोड़ें',
  'opac.review.awaiting': 'समीक्षाधीन',
  'opac.review.noTags': 'अभी कोई सामुदायिक टैग नहीं है',
  'opac.review.none': 'अभी कोई सामुदायिक समीक्षा नहीं है। अपने विचार साझा करने वाले पहले व्यक्ति बनें!',
  'opac.review.pending': 'धन्यवाद! आपकी समीक्षा मॉडरेशन के लिए प्रस्तुत कर दी गई है।',
  'opac.review.placeholder': 'इस शीर्षक के बारे में अपने विचार साझा करें...',
  'opac.review.post': 'समीक्षा पोस्ट करें',
  'opac.review.posted': 'आपकी समीक्षा पोस्ट हो गई!',
  'opac.review.rated': 'रेटिंग सहेजी गई!',
  'opac.review.ratings': '{count} रेटिंग्स पर आधारित',
  'opac.review.reviews': 'पाठकों की समीक्षाएँ',
  'opac.review.signInToRate': 'रेट करने के लिए साइन इन करें',
  'opac.review.tagged': 'टैग जोड़ा गया!',
  'opac.review.tags': 'टैग',
  'opac.review.write': 'एक समीक्षा लिखें',
  'opac.review.yourRating': 'आपकी रेटिंग',

  // rooms & equipment
  'opac.rooms.allKinds': 'सभी स्थान और उपकरण',
  'opac.rooms.approvalNote': 'इस बुकिंग के लिए पुस्तकालय कर्मचारियों की मंजूरी आवश्यक है। आपको जल्द ही अपडेट प्राप्त होगा।',
  'opac.rooms.attendees': 'प्रतिभागियों की संख्या',
  'opac.rooms.book': 'स्थान बुक करें',
  'opac.rooms.bookTitle': '{name} बुक करें',
  'opac.rooms.booked': 'बुकिंग की पुष्टि हुई!',
  'opac.rooms.closedDay': 'इस तारीख को पुस्तकालय बंद है।',
  'opac.rooms.confirm': 'बुकिंग की पुष्टि करें',
  'opac.rooms.date': 'बुकिंग तिथि',
  'opac.rooms.description': 'निजी अध्ययन कक्ष, बैठक स्थान और मल्टीमीडिया उपकरण आरक्षित करें।',
  'opac.rooms.duration': 'बुकिंग अवधि',
  'opac.rooms.empty': 'कोई कमरा या उपकरण उपलब्ध नहीं है',
  'opac.rooms.emptyHelp': 'एक अलग तिथि, समय या पुस्तकालय शाखा चुनने का प्रयास करें।',
  'opac.rooms.equipment': 'उपकरण',
  'opac.rooms.fee': 'अनुमानित शुल्क: {amount}',
  'opac.rooms.instant': 'तत्काल बुकिंग',
  'opac.rooms.kind': 'सुविधा प्रकार',
  'opac.rooms.needsApproval': 'स्वीकृति आवश्यक',
  'opac.rooms.noSlots': 'इस तारीख को कोई समय स्लॉट उपलब्ध नहीं है।',
  'opac.rooms.perHour': '{amount} / घंटा',
  'opac.rooms.purpose': 'बुकिंग का उद्देश्य',
  'opac.rooms.request': 'बुकिंग का अनुरोध करें',
  'opac.rooms.requested': 'बुकिंग का अनुरोध किया गया!',
  'opac.rooms.rooms': 'अध्ययन और बैठक कक्ष',
  'opac.rooms.seats': '{count} सीटें',
  'opac.rooms.signIn': 'बुक करने के लिए साइन इन करें',
  'opac.rooms.signInHelp': 'आरक्षण करने के लिए कृपया अपने पुस्तकालय खाते से साइन इन करें।',
  'opac.rooms.slots': 'एक समय स्लॉट चुनें',
  'opac.rooms.title': 'अध्ययन कक्ष और उपकरण',
  'opac.rooms.viewBookings': 'मेरी बुकिंग देखें',

  // search UI
  'opac.search.activeFilters': 'सक्रिय फ़िल्टर',
  'opac.search.alertsOff': 'अलर्ट बंद',
  'opac.search.alertsOn': 'अलर्ट चालू',
  'opac.search.clearFilters': 'फ़िल्टर साफ़ करें',
  'opac.search.didYouMean': 'क्या आपका मतलब था:',
  'opac.search.field': 'खोज फ़ील्ड',
  'opac.search.filtersOnly': 'फ़िल्टर खोज',
  'opac.search.grid': 'ग्रिड दृश्य',
  'opac.search.list': 'सूची दृश्य',
  'opac.search.noResults': 'कोई मेल खाते परिणाम नहीं मिले',
  'opac.search.noResultsHelp': 'वर्तनी जांचें, अपने खोज शब्दों को व्यापक बनाएं, या कुछ फ़िल्टर साफ़ करने का प्रयास करें।',
  'opac.search.noneSaved': 'कोई सहेजी गई खोज नहीं',
  'opac.search.noneSavedHelp': 'उन्हें तुरंत फिर से चलाने या अलर्ट प्राप्त करने के लिए अपनी पसंदीदा खोजें सहेजें।',
  'opac.search.notify': 'नए शीर्षक मेल खाने पर मुझे ईमेल करें',
  'opac.search.notifyHelp': 'जब मेल खाने वाली पुस्तकें पुस्तकालय में आएं तो सूचनाएं प्राप्त करें।',
  'opac.search.resultsFor': '"{q}" के लिए खोज परिणाम',
  'opac.search.save': 'खोज सहेजें',
  'opac.search.saveName': 'सहेजी गई खोज का नाम',
  'opac.search.saved': 'सहेजी गई खोजें',
  'opac.search.savedToast': 'खोज सफलतापूर्वक सहेजी गई!',
  'opac.search.showResults': '{count} परिणाम दिखाएँ',
  'opac.search.sort': 'क्रमबद्धता क्रम',
  'opac.search.suggestPurchase': 'खरीद के लिए एक शीर्षक का सुझाव दें',
  'opac.search.title': 'सूची खोज',
  'opac.search.view': 'दृश्य शैली',

  // miscellaneous & home
  'opac.by': 'द्वारा',
  'opac.byOwner': '{name} द्वारा क्यूरेट किया गया',
  'opac.cameraDenied': 'कैमरा अनुमति अस्वीकृत या कैमरा नहीं मिला',
  'opac.chip.fiction': 'काल्पनिक साहित्य',
  'opac.chip.hindi': 'हिन्दी साहित्य',
  'opac.chip.science': 'विज्ञान और प्रकृति',
  'opac.chip.upsc': 'सिविल सेवा / यूपीएससी',
  'opac.closedNow': 'अभी बंद है',
  'opac.closedToday': 'आज बंद है',
  'opac.emptyShelf': 'शेल्फ पर कोई शीर्षक नहीं',
  'opac.heroEyebrow': 'खोजें · सीखें · जुड़ें',
  'opac.hoursSoon': 'खुलने का समय जल्द ही अपडेट होगा',
  'opac.libraryHours': 'पुस्तकालय का समय',
  'opac.news': 'पुस्तकालय समाचार और सूचनाएं',
  'opac.nextClosure': 'आगामी बंदी: {date} को {title}',
  'opac.noRatings': 'अभी कोई रेटिंग नहीं',
  'opac.openNow': 'अभी खुला है',
  'opac.qrAlt': '{title} के लिए क्यूआर कोड',
  'opac.qrHelp': 'मोबाइल पर खोलने के लिए मोबाइल फ़ोन कैमरे से स्कैन करें',
  'opac.ratingOf': '5 में से {value} सितारे ({count} रेटिंग)',
  'opac.scanHint': 'अपने डिवाइस कैमरे से ISBN बारकोड स्कैन करें',
  'opac.scanIsbn': 'पुस्तक बारकोड स्कैन करें',
  'opac.scanIsbnHelp': 'पुस्तक के पीछे बारकोड पर कैमरा इंगित करें',
  'opac.seeAll': 'सभी देखें',
  'opac.share': 'शीर्षक साझा करें',
  'opac.staffPicks': 'कर्मचारियों की सिफारिशें',
  'opac.staffPicksHelp': 'पुस्तकालय क्यूरेटर द्वारा अनुशंसित संग्रह',
  'opac.stat.copies': 'कुल प्रतियाँ',
  'opac.stat.loans': 'ऋण (पिछले 30 दिन)',
  'opac.stat.members': 'सक्रिय सदस्य',
  'opac.stat.titles': 'संग्रह में शीर्षक',
  'opac.statFoot': 'साथ ही {events} आगामी सांस्कृतिक कार्यक्रम और कार्यशालाएं',
  'opac.titlesCount': '{count} शीर्षक',
  'opac.trySearching': 'लोकप्रिय खोजें',
  'opac.updated': 'अद्यतन {date}',
  'card.expiredAgo': "{days} दिन पहले समाप्त हुआ",
  'card.expiresSoon': "{days} दिनों में समाप्त होगा",
  'card.fullscreen': "फ़ुलस्क्रीन कार्ड",
  'card.libraryCard': "पुस्तकालय कार्ड",
  'card.noExpiry': "कोई समाप्ति तिथि नहीं",
  'card.number': "कार्ड संख्या",
  'card.offlineCopy': "ऑफ़लाइन संचित प्रति",
  'card.qrAlt': "डिजिटल पुस्तकालय कार्ड बारकोड और क्यूआर कोड",
  'card.qrUnavailable': "क्यूआर अनुपलब्ध",
  'card.savedOffline': "ऑफ़लाइन उपलब्ध",
  'card.scanHelp': "स्वयं चेकआउट या परिसंचरण डेस्क पर यह बारकोड या क्यूआर कोड दिखाएँ।",
  'card.validThru': "तक मान्य",
  'kiosk.askStaff': "कृपया परिसंचरण डेस्क पर पुस्तकालय कर्मचारियों से संपर्क करें।",
  'kiosk.backspace': "हटाएँ",
  'kiosk.borrow': "उधार लें",
  'kiosk.borrowed': "उधार ली गई वस्तुएँ",
  'kiosk.cardField': "कार्ड बारकोड",
  'kiosk.cardHelp': "आरंभ करने के लिए अपना पुस्तकालय कार्ड बारकोड स्कैन या दर्ज करें।",
  'kiosk.cardPlaceholder': "कार्ड बारकोड स्कैन या दर्ज करें",
  'kiosk.continue': "जारी रखें",
  'kiosk.differentCard': "एक अलग कार्ड का उपयोग करें",
  'kiosk.disabledHelp': "स्वयं चेकआउट वर्तमान में उपलब्ध नहीं है। कृपया परिसंचरण डेस्क पर जाएँ।",
  'kiosk.dueOn': "वापसी तिथि: {date}",
  'kiosk.enterPin': "अपना पिन दर्ज करें",
  'kiosk.fine': "विलंब शुल्क: ₹{amount} ({days} दिन)",
  'kiosk.finish': "समाप्त और लॉग आउट करें",
  'kiosk.itemField': "मद बारकोड",
  'kiosk.itemPlaceholder': "पुस्तक बारकोड स्कैन करें",
  'kiosk.loansNow': "खाते पर सक्रिय ऋण: {count}",
  'kiosk.mode': "चेकआउट मोड",
  'kiosk.notProcessed': "प्रक्रिया नहीं की गई वस्तुएं",
  'kiosk.nothing': "इस सत्र में कोई वस्तु स्कैन नहीं की गई।",
  'kiosk.pinEntered': "{count} अंक दर्ज किए गए",
  'kiosk.pinPrompt': "4-6 अंकों का पिन दर्ज करें",
  'kiosk.receipt': "सत्र रसीद",
  'kiosk.return': "वापस करें",
  'kiosk.returned': "सफलतापूर्वक वापस किया गया",
  'kiosk.returnedHeading': "वापस की गई वस्तुएँ",
  'kiosk.scanReturn': "वापस करने के लिए वस्तुएं स्कैन करें",
  'kiosk.thanks': "धन्यवाद!",
  'kiosk.timedOut': "निष्क्रियता के कारण सत्र समाप्त हो गया।",
  'kiosk.touchToStart': "शुरू करने के लिए स्पर्श करें",
  'kiosk.unreachable': "कियोस्क प्रणाली ऑफ़लाइन है",
  'opac.account.cannotBorrow': "आपके खाते पर उधार लेने के विशेषाधिकार वर्तमान में निलंबित हैं।",
  'opac.account.debarred': "खाता प्रतिबंधित",
  'opac.account.dueNext': "आगामी वापसी तिथियाँ",
  'opac.account.dueSoon': "शीघ्र देय",
  'opac.account.expired': "सदस्यता समाप्त",
  'opac.account.expiredHelp': "आपकी पुस्तकालय सदस्यता {date} को समाप्त हो गई थी। नवीनीकरण के लिए पुस्तकालय डेस्क पर जाएँ।",
  'opac.account.holdsReady': "पिकअप के लिए तैयार",
  'opac.account.noBookings': "कोई कमरा या उपकरण बुकिंग नहीं",
  'opac.account.noEvents': "कोई कार्यक्रम पंजीकरण नहीं",
  'opac.account.noLoans': "कोई सक्रिय ऋण नहीं",
  'opac.account.openRequests': "खुले अनुरोध",
  'opac.account.sections': "खाता अनुभाग",
  'opac.account.unread': "अपठित सूचनाएं",
  'opac.account.welcome': "पुनः स्वागत है,",
  'opac.dueSoon': "शीघ्र देय",
  'opac.dueToday': "आज देय",
  'opac.event.waitlistPos': "प्रतीक्षा सूची #{position}",
  'opac.fines.amount': "राशि",
  'opac.fines.balance': "वर्तमान शेष",
  'opac.fines.credits': "उपलब्ध क्रेडिट",
  'opac.fines.description': "विवरण",
  'opac.fines.dismissed': "भुगतान रद्द किया गया।",
  'opac.fines.empty': "कोई जुर्माना लेनदेन नहीं",
  'opac.fines.emptyHelp': "आपका कोई बकाया शुल्क या भुगतान दर्ज नहीं है।",
  'opac.fines.outstanding': "कुल बकाया",
  'opac.fines.paidBody': "आपका भुगतान सफलतापूर्वक दर्ज किया गया था।",
  'opac.fines.paidTitle': "{amount} का भुगतान सफल रहा",
  'opac.fines.pay': "{amount} का भुगतान करें",
  'opac.fines.payAtDesk': "डेस्क पर भुगतान करें",
  'opac.fines.providerFailed': "भुगतान गेटवे शुरू करने में असमर्थ। कृपया पुनः प्रयास करें या डेस्क पर भुगतान करें।",
  'opac.fines.receipt': "रसीद #{number}",
  'opac.fines.sandboxNote': "परीक्षण भुगतान मोड (सैंडबॉक्स)",
  'opac.fines.secureNote': "भुगतान एन्क्रिप्टेड गेटवे के माध्यम से सुरक्षित रूप से संसाधित किए जाते हैं।",
  'opac.fines.statement': "खाता विवरण",
  'opac.fines.toPay': "बकाया जुर्माना भरें",
  'opac.fines.voided': "रद्द किया गया",
  'opac.history.clear': "पठन इतिहास साफ़ करें",
  'opac.history.clearBody': "क्या आप वाकई अपना पूरा उधार इतिहास हटाना चाहते हैं? इसे पूर्ववत नहीं किया जा सकता।",
  'opac.history.clearTitle': "पठन इतिहास साफ़ करें?",
  'opac.history.cleared': "पठन इतिहास साफ़ कर दिया गया।",
  'opac.history.empty': "कोई पठन इतिहास नहीं",
  'opac.history.emptyHelp': "यदि पठन इतिहास सक्षम है तो आपके द्वारा लौटाई गई पुस्तकें यहाँ दर्ज की जाएंगी।",
  'opac.history.off': "पठन इतिहास अक्षम है",
  'opac.history.offHelp': "आपके द्वारा पढ़ी गई पुस्तकों का हिसाब रखने के लिए अपनी गोपनीयता सेटिंग्स में इतिहास रिकॉर्डिंग चालू करें।",
  'opac.history.policy.DEFAULT': "पुस्तकालय डिफ़ॉल्ट",
  'opac.history.policy.FOREVER': "हमेशा रखें",
  'opac.history.policy.NEVER': "रिकॉर्ड न करें",
  'opac.history.privacy': "पठन इतिहास गोपनीयता",
  'opac.history.privacyHelp.DEFAULT': "पुस्तकालय प्रतिधारण नीति का पालन करता है।",
  'opac.history.privacySaved': "गोपनीयता प्राथमिकताएं सहेजी गईं।",
  'opac.history.returned': "वापस किया गया {date}",
  'opac.history.search': "पठन इतिहास खोजें",
  'opac.holds.cancelBody': "क्या आप वाकई \"{title}\" के लिए अपना होल्ड रद्द करना चाहते हैं?",
  'opac.holds.cancelHold': "होल्ड रद्द करें",
  'opac.holds.cancelTitle': "होल्ड रद्द करें?",
  'opac.holds.cancelledToast': "होल्ड रद्द किया गया।",
  'opac.holds.edit': "होल्ड संपादित करें",
  'opac.holds.empty': "कोई होल्ड नहीं लगाया गया",
  'opac.holds.emptyHelp': "सूची खोजें और उपलब्ध होने पर एकत्र करने के लिए शीर्षकों पर होल्ड लगाएं।",
  'opac.holds.pickupBy': "तक एकत्र करें",
  'opac.holds.pickupByDate': "{date} तक एकत्र करें",
  'opac.holds.placedOn': "{date} को लगाया गया",
  'opac.holds.readyHelp': "कृपया पिकअप समय सीमा से पहले होल्डिंग डेस्क से अपनी वस्तुएं एकत्र करें।",
  'opac.holds.readyTitle': "{count} होल्ड पिकअप के लिए तैयार हैं!",
  'opac.holds.resume': "होल्ड पुनः शुरू करें",
  'opac.holds.resumedToast': "होल्ड पुनः शुरू किया गया।",
  'opac.holds.showHistory': "पुराने होल्ड दिखाएँ",
  'opac.holds.status.CANCELLED': "रद्द किया गया",
  'opac.holds.status.EXPIRED': "समाप्त",
  'opac.holds.status.FILLED': "एकत्रित किया गया",
  'opac.holds.status.IN_PROCESSING': "प्रसंस्करण में",
  'opac.holds.status.IN_TRANSIT': "पारगमन में",
  'opac.holds.status.PENDING': "कतार में प्रतीक्षा कर रहा है",
  'opac.holds.status.WAITING': "पिकअप के लिए तैयार",
  'opac.holds.suspend': "होल्ड निलंबित करें",
  'opac.holds.suspendHint': "निलंबित रहने के दौरान कतार में आपका स्थान सुरक्षित रहता है।",
  'opac.holds.suspendUntil': "तक निलंबित रखें",
  'opac.holds.suspended': "निलंबित",
  'opac.holds.suspendedToast': "होल्ड निलंबित किया गया।",
  'opac.holds.suspendedUntil': "{date} तक निलंबित",
  'opac.holds.updated': "होल्ड अद्यतन किया गया।",
  'opac.ill.article': "लेख या अध्याय का शीर्षक",
  'opac.ill.articleHint': "पत्रिका या पुस्तक अध्याय अनुरोधों के लिए",
  'opac.ill.cancel': "अनुरोध रद्द करें",
  'opac.ill.cancelTitle': "अंतर-पुस्तकालय ऋण अनुरोध रद्द करें?",
  'opac.ill.cancelled': "अंतर-पुस्तकालय ऋण अनुरोध रद्द किया गया।",
  'opac.ill.empty': "कोई अंतर-पुस्तकालय ऋण अनुरोध नहीं",
  'opac.ill.emptyHelp': "किसी अन्य पुस्तकालय प्रणाली से पुस्तक या पत्रिका की आवश्यकता है? एक ILL अनुरोध सबमिट करें।",
  'opac.ill.fee': "ILL शुल्क: ₹{amount}",
  'opac.ill.help': "साझेदार पुस्तकालयों से ल्यूमिना में उपलब्ध न होने वाली पुस्तकों और लेखों का अनुरोध करें।",
  'opac.ill.neededBy': "{date} तक आवश्यक",
  'opac.ill.neededByField': "आवश्यक तिथि",
  'opac.ill.new': "नया अंतर-पुस्तकालय ऋण अनुरोध",
  'opac.ill.requested': "{date} को अनुरोध किया गया",
  'opac.ill.send': "अनुरोध भेजें",
  'opac.ill.sent': "अंतर-पुस्तकालय ऋण अनुरोध भेजा गया।",
  'opac.list.deleteBody': "क्या आप वाकई \"{name}\" को हटाना चाहते हैं?",
  'opac.list.deleteTitle': "पठन सूची हटाएँ?",
  'opac.list.deleted': "पठन सूची हटा दी गई।",
  'opac.list.description': "विवरण",
  'opac.list.edit': "सूची संपादित करें",
  'opac.list.emptyList': "सूची खाली है",
  'opac.list.emptyListHelp': "इस सूची में जोड़ने के लिए कैटलॉग में शीर्षक खोजें।",
  'opac.list.moveDown': "नीचे ले जाएँ",
  'opac.list.moveUp': "ऊपर ले जाएँ",
  'opac.list.none': "अभी कोई सूची नहीं है",
  'opac.list.noneHelp': "अपने पठन और शोध को व्यवस्थित करने के लिए पठन सूचियाँ बनाएँ।",
  'opac.list.saved': "सूची सहेजी गई।",
  'opac.list.shareLink': "लिंक साझा करें",
  'opac.list.stopSharing': "साझा करना बंद करें",
  'opac.list.visibility': "दृश्यता",
  'opac.list.visibility.PRIVATE': "निजी",
  'opac.list.visibilityHelp.PRIVATE': "केवल आपको दिखाई देगी।",
  'opac.loans.cannotRenew': "नवीनीकरण नहीं किया जा सकता",
  'opac.loans.daysOverdue': "{count} दिन अतिदेय",
  'opac.loans.empty': "कोई सक्रिय ऋण नहीं",
  'opac.loans.emptyHelp': "किसी भी पुस्तकालय शाखा से आपके द्वारा उधार ली गई वस्तुएँ यहाँ दिखाई देंगी।",
  'opac.loans.renewAllResult': "{renewed} वस्तुएँ नवीनीकृत ({failed} विफल)",
  'opac.loans.renewFrom': "{date} से नवीनीकरण के लिए उपलब्ध",
  'opac.loans.renewalsLeft': "{count} नवीनीकरण शेष",
  'opac.loans.renewed': "ऋण सफलतापूर्वक नवीनीकृत हुआ।",
  'opac.loans.renewedTo': "{date} तक नवीनीकृत",
  'opac.me.address2': "पता पंक्ति 2",
  'opac.me.allRead': "सभी सूचनाओं को पढ़ा हुआ चिह्नित किया गया।",
  'opac.me.appearance': "प्रदर्शन और रूप-रंग",
  'opac.me.changePassword': "पासवर्ड बदलें",
  'opac.me.changePhoto': "फ़ोटो बदलें",
  'opac.me.currentPassword': "वर्तमान पासवर्ड",
  'opac.me.digest': "दैनिक सार भेजें",
  'opac.me.language': "पसंदीदा भाषा",
  'opac.me.markAllRead': "सभी को पढ़ा हुआ चिह्नित करें",
  'opac.me.markRead': "पढ़ा हुआ चिह्नित करें",
  'opac.me.medium.EMAIL': "ईमेल",
  'opac.me.member': "{date} से सदस्य",
  'opac.me.messaging': "अधिसूचना प्राथमिकताएँ",
  'opac.me.messagingHelp': "चुनें कि पुस्तकालय आपसे कैसे और कब संपर्क करे।",
  'opac.me.nameLocked': "अपना कानूनी नाम अपडेट करने के लिए, कृपया परिसंचरण डेस्क से संपर्क करें।",
  'opac.me.newPassword': "नया पासवर्ड",
  'opac.me.noNotifications': "कोई सूचना नहीं",
  'opac.me.noNotificationsHelp': "पिकअप नोटिस, देय तिथि अनुस्मारक और पुस्तकालय अपडेट यहाँ दिखाई देंगे।",
  'opac.me.noticeType': "सूचना प्रकार",
  'opac.me.passwordChanged': "पासवर्ड सफलतापूर्वक अपडेट किया गया।",
  'opac.me.photoSaved': "प्रोफ़ाइल फ़ोटो सहेजी गई।",
  'opac.me.prefsSaved': "अधिसूचना प्राथमिकताएं सहेजी गईं।",
  'opac.me.saved': "प्रोफ़ाइल सहेजी गई।",
  'opac.me.secondaryEmail': "द्वितीयक ईमेल",
  'opac.me.theme': "थीम",
  'opac.me.themeDark': "डार्क",
  'opac.me.themeLight': "लाइट",
  'opac.me.themeSystem': "सिस्टम डिफ़ॉल्ट",
  'opac.rooms.bookings': "मेरी बुकिंग",
  'opac.rooms.cancel': "बुकिंग रद्द करें",
  'opac.rooms.cancelTitle': "कमरे की बुकिंग रद्द करें?",
  'opac.rooms.cancelled': "बुकिंग रद्द कर दी गई।",
  'opac.suggest.author': "लेखक",
  'opac.suggest.empty': "कोई खरीद सुझाव नहीं",
  'opac.suggest.emptyHelp': "क्या आप चाहते हैं कि पुस्तकालय कोई पुस्तक खरीदे? एक खरीद सुझाव सबमिट करें।",
  'opac.suggest.help': "पुस्तकालय संग्रह के लिए शीर्षक सुझाएँ। पुस्तकालयाध्यक्ष आपके अनुरोध की समीक्षा करेंगे।",
  'opac.suggest.new': "एक खरीद का सुझाव दें",
  'opac.suggest.publisher': "प्रकाशक",
  'opac.suggest.reason': "सुझाव का कारण",
  'opac.suggest.send': "सुझाव भेजें",
  'opac.suggest.sent': "खरीद सुझाव प्रस्तुत किया गया।",
  'opac.suggest.titleField': "शीर्षक",
  'opac.suggest.withdraw': "सुझाव वापस लें",
  'opac.suggest.withdrawTitle': "खरीद सुझाव वापस लें?",
  'opac.suggest.withdrawn': "खरीद सुझाव वापस ले लिया गया।",
};
